import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDumpsterFire, faCode, faFileCode } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Aos from 'aos';
import "aos/dist/aos.css"
const serviceData = [
    {
        icon: faDumpsterFire,
        name: 'Ecommerce',
        description: 'I will design and develop ecommerce online store website.'
    },
    {
        icon: faCode,
        name: 'Web Design',
        description: 'Qualified web design and attractive effects which catches visitor’s Eye.'
    },
    {
        icon: faFileCode,
        name: 'Web Development',
        description: 'Clean and fresh issue free code to make your website dynamic perfectly.'
    }
]

const Services = () => {
    useEffect(() => {
        Aos.init({duration:2000});
    },[]);
    return (

        <main>
            <Container className="text-center mt-3 pt-5  myService" style={{ background: "#f0f2f2", border: "2px outset #f32a74"}}>
            <h2 data-aos="zoom-out" className="page-title text-left">My Services</h2>
                <Row>
                    {
                        serviceData.map(data =>
                            <Col lg={4} md={6} sm={12}>
                                <div data-aos="flip-up" className="serviceCard text-center px-3 pb-5">
                                {data.amination}
                                    <p data-aos="zoom-in-up" className="serviceIcon" style={{ color: "#f32a74", fontSize: "2rem" }}><FontAwesomeIcon icon={data.icon} /></p>

                                    <h2 data-aos="zoom-out-up" className="serviceName">{data.name}</h2>
                                    <p data-aos="fade-left" className="decT">{data.description}</p>
                                    {/* <Link to="/serviceDetails"> <Button data-aos="fade-up" variant="outline-success btn-sm">Read Details</Button></Link> */}
                                    <Link data-aos="fade-up" to="/serviceDetails" className="btn text-center dwnBtn">Read Details</Link>
                                </div>
                            </Col>
                        )
                    }
                </Row>
            </Container>
        </main>

        

    );
};

export default Services;